<template>
  <div>
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ titulo }} </strong>
          </div>
          <b-row>
            <b-col sm="12" md="12">
              <b-card>

                  <b-card-body>
                      <b-button 
                            variant="secondary"
                            @click="regresar()">
                            Regresar
                        </b-button>
                  </b-card-body>

                  <item-header
                    :headerUp="header"
                    tipoItem="seccion"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                  ></item-header>

                

                <!--  ========================== SECCIONES ================================ -->

                  <item-secciones
                    :secciones="submenu"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                  ></item-secciones>

                  <!--  ========================== PUESTOS ================================ -->

                  <b-card-body>
                      <item-puestos
                        :puestos="puestos"
                        @enviandoStart="enviando=true"
                        @enviandoStop="enviando=false"
                      ></item-puestos>
                  </b-card-body>

                  <b-card-body>
                      <b-button 
                            variant="secondary"
                            @click="regresar()">
                            Regresar
                        </b-button>
                  </b-card-body>

              </b-card>

            </b-col>
            
          </b-row>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import ItemHeader from './ItemHeader';
import ItemSecciones from './ItemSecciones';
import ItemPuestos from './ItemPuestos';

export default {
  name: 'DirectorioSeccion',
  components: {
   Loader,
   ItemHeader,
   ItemSecciones,
   ItemPuestos
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ])
  },
  data: function () {
    return {
        titulo: this.$route.name,
        enviando: false,
        id: this.$route.params.id,
        header:{},
        submenu: [],
        puestos:[]
    }
  },
  watch: {
    '$route'(to, from) {
        this.id = to.params.id;
        if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 123) < 0)
            this.$router.go(-1);
        this.enviando = true;
        axios.get(this.httpURL+'/comsocial/directorio/menu/'+to.params.id,{headers:{token:this.sessionToken}})
                .then(res => {
                    //console.log(res.data);
                    this.header = {
                        nombre: res.data.menu.nombre,
                        descripcion: res.data.menu.descripcion
                    }
                    this.submenu = res.data.menu.submenu;
                    this.puestos = res.data.menu.puestos;
                    this.enviando = false;
                })
                .catch(error => {
                    if(error.response){
                        swal("Oops!",error.response.data.mensaje , "error")
                    }else if( error.request){
                        swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                    }
                    this.enviando = false;
                });
    }
  },
  created(){
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 123) < 0)
        this.$router.go(-1);
      this.enviando = true;
      axios.get(this.httpURL+'/comsocial/directorio/menu/'+this.id,{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.header = {
                      nombre: res.data.menu.nombre,
                      descripcion: res.data.menu.descripcion
                  }
                  this.submenu = res.data.menu.submenu;
                  this.puestos = res.data.menu.puestos;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
    regresar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
  .quill-editor,
  .quill-code {
    width: 100%;
    float: left;
  }
  .quill-code {
    height: auto;
    border: none;
    > .title {
      border: 1px solid #ccc;
      border-left: none;
      height: 3em;
      line-height: 3em;
      text-indent: 1rem;
      font-weight: bold;
    }
    > code {
      width: 100%;
      margin: 0;
      padding: 1rem;
      border: 1px solid #ccc;
      border-top: none;
      border-left: none;
      border-radius: 0;
      height: 30rem;
      overflow-y: auto;
    }
  }
</style>